/* tslint:disable */
/* eslint-disable */
export enum PositionType {
  FullTime = 'FullTime',
  PartTime = 'PartTime'
}
